import { render, staticRenderFns } from "./LiveSetup.vue?vue&type=template&id=500ed5df&"
import script from "./LiveSetup.vue?vue&type=script&lang=js&"
export * from "./LiveSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports